export enum EServiceChangeRequestSection {
  OVERVIEW = 'OVERVIEW',
  FORM = 'FORM',
  PRICING = 'PRICING',
  WORKFLOW = 'WORKFLOW',
  TRANSLATION = 'TRANSLATION',
  _UNKOWN_ = '_UNKOWN_',
}
